import axios from '../utils/axios';

export default function editShowcaseCompany(adminId, id, data) {
    return (
        axios.post(`/admin/${adminId}/showcase-companies/${id}`, data)
    )
}
